import Flex from 'style-utils/components/Flex';
import { ReactComponent as coteSportLogo } from 'assets/icons/logos/largeCoteSportLogo.svg';
import Icon from 'components/Icon/Icon';
import { H3, Span } from 'components/Typography';
import Button from 'components/Button/Button';
import { useNavigate } from 'react-router-dom';

const InternalServerError = () => {
  const navigate = useNavigate();
  const goToMainPage = () => {
    navigate('/');
  };
  return (
    <Flex
      as="main"
      flexDirection="column"
      alignItems="center"
      p="0 3rem 10rem 0"
      my="auto"
    >
      <Icon
        m="0 auto"
        svgIconComponent={coteSportLogo}
        iconSize="16.8rem"
        iconHeight="8.9rem"
      />
      <H3 variant="H3" i18nKey="internalServerError.error" m="3.8rem 0 .9rem" />
      <Span i18nKey="internalServerError.message" mb="3.8rem" />
      <Button
        onClick={goToMainPage}
        i18nKey="internalServerError.goToMainPage"
      />
    </Flex>
  );
};

export default InternalServerError;
